/**
 * The cache tags used by rtk query.
 * Any tags added to this enum will be automatically registered w/ the main apiSlice.
 */
export enum Tags {
  Example = 'Example',
  AccessSettingsMultifactor = 'AccessSettingsMultifactor',
}
